<template>
  <div class="home page-paper">
    <paper-view-lazy :paper-date="today" />
  </div>
</template>

<script>
import PaperViewLazy from "@/components/viewer/PaperViewLazy.vue";

export default {
  name: "Home",
  data: () => ({
    today: new Date(),
  }),
  components: {
    PaperViewLazy,
  },
};
</script>

<style lang="scss">
.page-paper {
  margin: 0 auto;
  width: auto;
}
</style>